import { render, staticRenderFns } from "./EditObjective.vue?vue&type=template&id=07a3d136&scoped=true"
import script from "./EditObjective.vue?vue&type=script&lang=js"
export * from "./EditObjective.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a3d136",
  null
  
)

export default component.exports